import { Component, Input, OnInit } from '@angular/core';

import { CourtEventNoteModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-court-event-notes-details',
    templateUrl: './court-event-notes-details.component.html',
    styleUrls: ['./court-event-notes-details.component.scss'],
    standalone: false
})
export class CourtEventNotesDetailsComponent implements OnInit {

    @Input() notes: CourtEventNoteModel[];

    constructor() { }

    ngOnInit(): void {
    }
}
